import React from 'react';

import dashboard from '../../../images/blue_dashboard_ic.svg';

import { FOHImage } from '../../ingredients';

export const FOHBlueDashboardIcon = () => (
  <FOHImage source={{ uri: dashboard }} style={{ width: 24, height: 24 }} />
);
